import { Platform } from './Platform';
import { Usage } from './Usage';
import { Reports } from './Reports';

// =============================================================================
// H9 > 운영사 > 대시보드 — 조회(대시보드) 성향의 운영 도구 3종을 한 화면으로.
//   모니터링(Platform) · 사용량(Usage) · 리포트(Reports)
// 각 페이지는 자체 PageContainer(h-full overflow-auto)를 갖고 있어, 여기서는
// 바깥에서 한 번만 스크롤하도록 자식 컨테이너의 높이/스크롤을 무력화한다.
// =============================================================================

export function OpsDashboard(): JSX.Element {
  const sectionCls =
    '[&>div]:!h-auto [&>div]:!overflow-visible border-b border-line last:border-0';
  return (
    <div className="h-full overflow-auto">
      <section className={sectionCls}>
        <Platform />
      </section>
      <section className={sectionCls}>
        <Usage />
      </section>
      <section className={sectionCls}>
        <Reports />
      </section>
    </div>
  );
}
